import { onDesktop } from "@naf/teamscheme";
import { ClickBackLink, LinkBackLink } from "@naf/teamscheme";
import { type HTMLAttributes, type ReactNode, forwardRef } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { PageContainer, type PageProps, type PageRef } from "../layout/Page";
import PageFooter from "../layout/PageFooter";
import StaticHeader from "../layout/header/StaticHeader";
import { getRelativePath } from "../../routing/AppRoutes";
import { AppPage } from "../../routing/AppPage";

export const AboutContent = styled.div`
  max-width: 40em;
  ${({ theme }) => onDesktop`
    padding: ${theme.spacing.space24} ${theme.spacing.space48};
  `}
`;

export const StaticPageElement = styled((x: PageProps) => (
  <StaticPage {...x} />
))`
  h1 {
    text-align: center;
  }
`;

export interface AboutPageProps {
  title: string;
  children: ReactNode;
  backTo?: string;
}

export function BackLink({
  backTo,
  ...props
}: { backTo?: string } & Omit<HTMLAttributes<HTMLAnchorElement>, "onClick">) {
  const navigate = useNavigate();
  const label = "Tilbake";
  return backTo ? (
    <LinkBackLink to={backTo} {...props}>
      {label}
    </LinkBackLink>
  ) : history.length > 1 ? (
    <ClickBackLink onClick={() => navigate(-1)} {...props}>
      {label}
    </ClickBackLink>
  ) : (
    <LinkBackLink to={getRelativePath(AppPage.LandingPage)} {...props}>
      {label}
    </LinkBackLink>
  );
}

export const GreenStaticHeader = styled(StaticHeader)`
  background-color: ${({ theme }) => theme.nafColor.primary.dew};
`;

export const GreenPageContainer = styled(PageContainer)`
  background-color: ${({ theme }) => theme.nafColor.primary.dew};
`;

export interface StaticPageProps extends PageProps {
  greenHeader?: boolean;
  greenBackground?: boolean;
}

const StaticPage = forwardRef<PageRef, StaticPageProps>(
  (
    {
      children,
      greenHeader = false,
      greenBackground = false,
      footer = false,
      ...rest
    },
    ref,
  ) => {
    return (
      <>
        {greenHeader ? <GreenStaticHeader /> : <StaticHeader />}
        {greenBackground ? (
          <GreenPageContainer ref={ref} {...rest}>
            {children}
          </GreenPageContainer>
        ) : (
          <PageContainer ref={ref} {...rest}>
            {children}
          </PageContainer>
        )}
        {footer ? <PageFooter /> : null}
      </>
    );
  },
);

export default StaticPage;
